<template>
    <div>
        <div class="mt-4 mb-5 text-left">
            <p class="text-lg mb-0">Restaurar Contraseña</p>
            <p class="text-md mb-0">{{ data.type }}{{ data.id }} - {{ data.name }}</p>
            <p class="text-sm mb-0">{{ data.email }}</p>
            <p class="text-sm text-muted mb-0">{{ data.account_type ? accounts.find((e) => e.value == data.account_type).text : '' }}</p>
        </div>
        <form @submit.prevent="CHANGE()">
            <div class="form-group mb-3">
                <small class="input-title">Contraseña</small>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">
                            <i class="bi bi-lock"></i>
                        </span>
                    </div>
                    <v-text-field v-model="data.password"
                        :append-icon="type ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="type ? 'text' : 'password'" class="form-control" hide-details
                        @click:append="type = !type"
                        :class="errors.password ? 'is-invalid' : ''">
                    </v-text-field>
                    <small class="invalid-feedback" v-for="(error, index) in errors.password"
                        :key="index">{{ error }}</small>
                </div>
            </div>
            <div class="form-group mb-3">
                <small class="input-title">Confirmar contraseña</small>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">
                            <i class="bi bi-lock"></i>
                        </span>
                    </div>
                    <v-text-field v-model="data.password_confirmation"
                        :append-icon="type_confirm ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="type_confirm ? 'text' : 'password'" class="form-control" hide-details
                        @click:append="type_confirm = !type_confirm"
                        :class="errors.password_confirmation ? 'is-invalid' : ''">
                    </v-text-field>
                    <small class="invalid-feedback" v-for="(error, index) in errors.password_confirmation"
                        :key="index">{{ error }}</small>
                </div>
            </div>
            <div class="form-group mb-3">
                <button type="submit" class="btn btn-primary btn-x w-100">
                    <div class="spinner-border spinner-border-sm" role="status"
                        v-if="count == 1">
                        <span class="sr-only">Loading...</span>
                    </div>
                    <span v-else>Guardar contraseña</span>
                </button>
            </div>
            <div class="form-group">
                <router-link :to="{ name: 'Login' }" class="btn btn-dark btn-x w-100">
                    <span>Atrás para iniciar sesión</span>
                </router-link>
            </div>
        </form>
    </div>
</template>
<script>
export default {
    data() {
        return {
            type: false,
            type_confirm: false,
            data: {
                email: '',
            },
            errors: {},
            count: 0,
            hash: this.$route.query.hash,
            accounts: [
                { value: 0, text: 'Sistema' },
                { value: 1, text: 'Personal' },
                { value: 2, text: 'Empresarial' },
            ],
        }
    },
    mounted() {
        this.INIT()
    },
    methods: {
        INIT: function () {
            let vue = this
            axios({ url: '/verify/token/' + vue.hash, method: 'GET' })
                .then((resp) => {
                    vue.data = resp.data
                })
                .catch((err) => {
                   let message = err.response ? err.response.data.message : err.message
                    vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    vue.$router.push({ name: 'Login' })
                })
                .finally((resp) => {
                    vue.loading = false
                })
        },
        CHANGE: function () {
            let vue = this
            vue.count++
            vue.errors = {}
            if (vue.count == 1) {
                axios({ url: '/password/reset/' + vue.hash, method: 'POST', data: vue.data })
                    .then((resp) => {
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        vue.$router.push({ name: 'Login' })
                    })
                    .catch((err) => {
                        if (err.response.status !== 422) {
                            let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.errors = err.response.data
                        }
                    })
                    .finally((resp) => {
                        vue.count = 0
                    })
            }
        }
    }
};
</script>
  